import { useState } from 'react'

export const usePopoverState = () => {
  const [selectedSlot, setSelectedSlot] = useState(null)
  const [createPopoverAnchor, setCreatePopoverAnchor] = useState(null)
  const [viewPopoverAnchor, setViewPopoverAnchor] = useState(null)

  const openCreatePopover = (slot, anchor) => {
    setSelectedSlot(slot)
    setCreatePopoverAnchor(anchor)
  }

  const openViewPopover = (slot, anchor) => {
    setSelectedSlot(slot)
    setViewPopoverAnchor(anchor)
  }

  const closeAllPopovers = () => {
    setSelectedSlot(null)
    setCreatePopoverAnchor(null)
    setViewPopoverAnchor(null)
  }

  return {
    selectedSlot,
    createPopoverAnchor,
    viewPopoverAnchor,
    openCreatePopover,
    openViewPopover,
    closeAllPopovers,
  }
} 